import React from 'react';
import PropTypes from 'prop-types';

import Message, {
  TYPE
} from '@mos-front-components/public/es/components/Message/Message';

import {
  BIRTH_REG_PLACES_VALUES,
  DOCUMENT_TYPE,
  MAIN_DATA_FIELD_NAMES
} from '../../constants/citizenship';
import { ACT_RECORD_FIELD_NAMES } from '../../constants/actRecord';

import Datepicker from '../Datepicker/Datepicker';

import actRecordPicture from './private/act_rec@2x.png';
import ActRecordNumberField from './private/ActRecordNumberField';
import RegPlaceName from './private/RegPlaceName/RegPlaceName';

import './ActRecord.pcss';

const ActRecord = props => {
  const {
    mainData,
    passportData,
    actRecordData,
    actRecordBlur,
    suggestions,
    fetching,
    fetchingError,
    onFindRegPlace,
    showTitle = true,
    showHint = true,
    saveDraft,
    onChange,
    onBlur
  } = props;
  if (passportData) {
    const birthRegistrationPlace =
      mainData[MAIN_DATA_FIELD_NAMES.birthRegistrationPlace].value;
    const documentType = passportData.type.value;
    const visible =
      birthRegistrationPlace === BIRTH_REG_PLACES_VALUES.RF &&
      documentType === DOCUMENT_TYPE.BIRTH_CERTIFICATE_RF;

    if (!visible) {
      return null;
    }
  }

  const dateFieldData = actRecordData[ACT_RECORD_FIELD_NAMES.date];
  const numberFieldData = actRecordData[ACT_RECORD_FIELD_NAMES.number];
  const numberBlur = actRecordBlur[ACT_RECORD_FIELD_NAMES.number];
  const regPlaceFieldData = actRecordData[ACT_RECORD_FIELD_NAMES.regPlace];
  const regPlaceBlur = actRecordBlur[ACT_RECORD_FIELD_NAMES.regPlace];
  const showNumberError = numberFieldData.error && numberBlur;
  const showRegPlaceError = regPlaceFieldData.error && regPlaceBlur;

  return (
    <div className="ActRecord">
      <div className="Form_Row">
        <div className="Form_MainCol">
          {showTitle && (
            <div className="ActRecord__title">
              Сведения об актовой записи о рождении
            </div>
          )}

          <div className="GiaFormGrid__row">
            <div className="GiaFormGrid_col">
              <Datepicker
                name={ACT_RECORD_FIELD_NAMES.date}
                placeholder="Дата составления актовой записи"
                dateFieldData={dateFieldData}
                errorLocation="placeholder"
                onChange={onChange}
                saveDraft={saveDraft}
              />
            </div>
            <div className="GiaFormGrid_col">
              <ActRecordNumberField
                actRecordData={actRecordData}
                blurred={numberBlur}
                onChange={onChange}
                onBlur={onBlur}
                saveDraft={saveDraft}
              />
            </div>
          </div>

          {(dateFieldData.error || showNumberError || showRegPlaceError) && (
            <div className="GiaFormGrid__row">
              <div className="GiaFormGrid_col">
                <Message
                  className="ActRecord__error"
                  type={TYPE.ERROR}
                  smallerText
                  bordered
                >
                  Введите {dateFieldData.error && 'дату'}
                  {dateFieldData.error &&
                    showNumberError &&
                    showRegPlaceError &&
                    ', '}
                  {dateFieldData.error &&
                    showNumberError &&
                    !showRegPlaceError &&
                    ' и '}
                  {showNumberError && 'номер'}
                  {(dateFieldData.error || showNumberError) &&
                    showRegPlaceError &&
                    ' и '}
                  {showRegPlaceError && 'наименование органа ЗАГС'}
                </Message>
              </div>
            </div>
          )}

          <div className="GiaFormGrid__row">
            <div className="GiaFormGrid_col">
              <RegPlaceName
                suggestions={suggestions}
                fetching={fetching}
                fetchingError={fetchingError}
                value={regPlaceFieldData.value}
                error={regPlaceFieldData.error}
                onChange={onChange}
                onBlur={onBlur}
                saveDraft={saveDraft}
                onFindRegPlace={onFindRegPlace}
              />
            </div>
          </div>
        </div>

        {showHint && (
          <div className="Form_Aside">
            <div className="Content_sub">
              <p>Не путайте номер актовой записи с номером свидетельства.</p>
              <p>
                <img
                  src={actRecordPicture}
                  alt="Свидетельство о рождении"
                  height={190}
                />
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

ActRecord.propTypes = {
  mainData: PropTypes.shape({}),
  passportData: PropTypes.shape({}),
  actRecordData: PropTypes.shape({}).isRequired,
  actRecordBlur: PropTypes.shape({}).isRequired,
  showTitle: PropTypes.bool,
  showHint: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  saveDraft: PropTypes.func
};

export default ActRecord;
